import { ICON_VARIANTS } from 'lib/constants/iconSizes';

export const isStandardVariant = sizing => ICON_VARIANTS.STANDARD.includes(sizing);
